import React from "react";
import CuadroPaises from "./CuadroPaises.js";
import CuadroTorneosSelec from "./selecciones/CuadroTorneosSelec.js";
import CuadroUltimosCampeonesSelec from "./selecciones/CuadroUltimosCampeonesSelec.js";
import * as Confederaciones from "../constantes/Confederaciones.js";
import styles from "./HomeTorneosSelec.module.css";

const organizadores = [
  {id: 0, nombre: "FIFA", oficialidad: 3},
  Confederaciones.CONMEBOL,
  Confederaciones.UEFA,
  Confederaciones.CONCACAF,
  Confederaciones.CAF,
  Confederaciones.AFC,
  Confederaciones.OFC,
];

const HomeTorneosSelec = (props) => {

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.columnaTorneos}`}>
        <CuadroTorneosSelec organizadores={organizadores} />
      </div>
      <div className={`${styles.columnaCampeones}`}>
        <CuadroUltimosCampeonesSelec organizadores={organizadores} />
      </div>
      <div className={`${styles.columnaPaises}`}>
        <CuadroPaises
          titulo="selecciones"
          incluirPrincipales={false}
          pathLinks="/selecciones/"
        />
      </div>
    </div>
  );
};

export default HomeTorneosSelec;